import styled from 'styled-components';

export const FrameStyles = styled.section`
  iframe {
    border-radius: 12px;
  }
`;
